import React, { useState, useEffect } from "react";
import { Table, Container } from "react-bootstrap";
import { pagamentos_pix, pagamentos_credito } from "../../services/api";
import TabelaPagamentosMol from "./Tabela_Pagamentos_Mol";

const Pagamentos_online = () => {
    // Datas fixadas conforme seu código original
    const [dataInicio] = useState('2024-08-31');
    const [dataFim] = useState(() => {
        const amanha = new Date();
        amanha.setDate(amanha.getDate() + 1);
        return amanha.toISOString().split('T')[0];
    });

    const [status] = useState('APPROVED');
    const [dataPix, setDataPix] = useState([]);
    const [dataCC, setDataCC] = useState([]);
    const [isloading, setIsloading] = useState(true);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', '', '', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    const fetchData = async () => {
        try {
            const [resultadoCC, resultadoPix] = await Promise.all([
                pagamentos_credito(dataInicio, dataFim, status),
                pagamentos_pix(dataInicio, dataFim, status)
            ]);
            setDataCC(resultadoCC || []);
            setDataPix(resultadoPix || []);
        } catch (error) {
            console.error("Erro ao buscar pagamentos:", error);
        } finally {
            setIsloading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [dataInicio, dataFim, status]);

    // Contadores unificados
    let pagamentosPorUnidadePix = {};
    let pagamentosPorUnidadeCC = {};

    // Processamento PIX
    dataPix.forEach(item => {
        const unidadeIndex = parseInt(item.customer_id.slice(0, 2));
        const unidadeNome = unidades[unidadeIndex];
        if (unidadeNome) {
            pagamentosPorUnidadePix[unidadeNome] = (pagamentosPorUnidadePix[unidadeNome] || 0) + 1;
        }
    });

    // Processamento Cartão de Crédito
    dataCC.forEach(item => {
        const unidadeIndex = parseInt(item.customer_id.slice(0, 2));
        const unidadeNome = unidades[unidadeIndex];
        if (unidadeNome) {
            pagamentosPorUnidadeCC[unidadeNome] = (pagamentosPorUnidadeCC[unidadeNome] || 0) + 1;
        }
    });

    // Unificando e calculando totais
    let totalPixGeral = 0;
    let totalCCGeral = 0;
    let totalGeral = 0;

    const pagamentosUnificados = unidades
        .filter(unidade => unidade !== '')
        .map(unidade => {
            const pix = pagamentosPorUnidadePix[unidade] || 0;
            const cc = pagamentosPorUnidadeCC[unidade] || 0;
            const total = pix + cc;

            totalPixGeral += pix;
            totalCCGeral += cc;
            totalGeral += total;

            return { unidade, pix, cc, total };
        })
        .filter(row => row.total > 0) // Esconde unidades que não tiveram nenhuma venda
        .sort((a, b) => a.unidade.localeCompare(b.unidade));

    return (
        <div className="mt-3">
            <Container fluid className="p-0">
                <div className="table-responsive shadow-sm rounded border">
                    <Table hover bordered className="text-center align-middle bg-white m-0 tabela-matriculas">
                        <thead className="table-dark">
                            <tr>
                                <th className="text-start ps-3">UNIDADE</th>
                                <th>PAGAMENTOS PIX</th>
                                <th>PAGAMENTOS CRÉDITO</th>
                                <th>TOTAL GERAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isloading ? (
                                <tr><td colSpan="4" className="py-4 text-muted">Carregando dados financeiros...</td></tr>
                            ) : pagamentosUnificados.length === 0 ? (
                                <tr><td colSpan="4" className="py-4 text-muted">Nenhum pagamento encontrado no período.</td></tr>
                            ) : (
                                pagamentosUnificados.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="text-start fw-bold bg-light ps-3">{row.unidade}</td>
                                        <td>{row.pix}</td>
                                        <td>{row.cc}</td>
                                        <td className="fw-bold text-success">{row.total}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                        {!isloading && pagamentosUnificados.length > 0 && (
                            <tfoot className="fw-bolder border-top border-dark bg-light">
                                <tr>
                                    <td className="text-start ps-3">TOTAL DA REDE</td>
                                    <td>{totalPixGeral}</td>
                                    <td>{totalCCGeral}</td>
                                    <td className="text-success" style={{ fontSize: '1.1em' }}>{totalGeral}</td>
                                </tr>
                            </tfoot>
                        )}
                    </Table>
                </div>
                <div className="mt-4">
                    Tabela Pagamentos MOL
                    <TabelaPagamentosMol />
                </div>
            </Container>
        </div>
    );
}

export default Pagamentos_online;